import { Component, ElementRef, OnInit } from "@angular/core";
import {
    makeStateKey,
    Meta,
    Title,
    TransferState,
} from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";

import { BlogService } from "../../shared/blog.service";
import { Blog } from "../../shared/model/blogs";

const LATESTBLOG = makeStateKey("blogLatest");

@Component({
    selector: "mlp-blog-homepage",
    templateUrl: "./blog-homepage.component.html",
})
export class BlogHomepageComponent implements OnInit {
    blogLatestCollection = [];
    private init = true;

    constructor(
        public blogService: BlogService,
        private activatedRoute: ActivatedRoute,
        private transferState: TransferState,
        private router: Router,
        private meta: Meta,
        private title: Title
    ) {
        const stateTransferData = this.transferState.get(
            LATESTBLOG,
            undefined as { blogData: Array<Blog>; blogsLatestTotal: number }
        );
        if (stateTransferData) {
            this.blogLatestCollection = stateTransferData.blogData;
            this.blogService.blogsLatestTotal =
                stateTransferData.blogsLatestTotal;
        }
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe(() => {
            const page = Number(this.activatedRoute.snapshot.queryParams.page);

            this.blogService.blogsLatestPage = page ? page : 1;
            if (!this.blogLatestCollection.length) this.getLatestBlogs();
        });

        setTimeout(() => {
            const page = Number(this.activatedRoute.snapshot.queryParams.page);

            if (page) {
                this.blogService.blogsLatestPage = page;
            }

            this.init = false;
        }, 2000);

        this.updateMetaData();
    }

    pageChange(page: number): void {
        if (!this.init) {
            this.blogService.blogsLatestPage = page;

            this.router.navigate(["/blog"], {
                queryParams: {
                    page: this.blogService.blogsLatestPage,
                },
            });

            this.getLatestBlogs();
        }
    }

    private getLatestBlogs(): void {
        if (!this.init) {
            this.blogService.loading = true;
        }

        this.blogService
            .getBlogLatest(
                this.blogService.blogsLatestPage,
                this.blogService.blogsLatestPerPage
            )
            .subscribe((data) => {
                this.blogLatestCollection = data;
                this.blogService.loading = false;

                this.transferState.set(LATESTBLOG, {
                    blogData:
                        this.blogService.stripOutScriptTagsCollection(data),
                    blogsLatestTotal: this.blogService.blogsLatestTotal,
                });
            });
    }

    private updateMetaData(): void {
        const title = "Playfinder Blog | Stories From the World of Sport";
        const metaDescription =
            "The Playfinder Blog keeps you up to date with fun and interesting stories from the " +
            "sporting world. Follow us for articles covering grassroots sport, things to do, and major sporting events.";

        if (this.title.getTitle() !== title) {
            this.title.setTitle(title);
            this.meta.updateTag({ property: "og:title", content: title });
            this.meta.updateTag({ property: "twitter:title", content: title });
        }

        this.meta.updateTag({ name: "description", content: metaDescription });
        this.meta.updateTag({
            property: "og:description",
            content: metaDescription,
        });
    }
}
